import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { submissionChannels } from "@/mocks/site";

export default function Channels() {
  return (
    <section className="w-full max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
      <Reveal>
        <SectionHeading
          eyebrow="投稿方式"
          title="四种投喂瓜料的方式，任选一种"
          desc="不需要注册，不需要实名。无论你是想随手说一句，还是想完整还原一整条时间线，511爆料的匿名投稿入口都为你留着。"
        />
      </Reveal>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {submissionChannels.map((channel, index) => (
          <Reveal key={channel.id} delay={index * 80}>
            <div className="h-full p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/70">
              <span className="w-12 h-12 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className={`${channel.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                {channel.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{channel.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}